import Head from 'next/head'
import prismic from 'services/prismic'

import CollectionHeader from 'components/CollectionHeader'
import Spacer from 'components/Spacer'
import SpecialCollectionCard from 'components/SpecialCollectionCard'

import { Collections, Root } from './index.style'

export default function Index({ document }) {
  return (
    <>
      <Head>
        <title>Collections - The Armoury</title>
      </Head>
      <Root>
        <CollectionHeader title="Collections" description={document.data.introduction} />
        <Spacer y={12} />
        <Collections>
          {document.data.collections
            .map(({ collection }) => collection)
            .map(({ id, ...props }, index) => (
              <div key={id}>
                <SpecialCollectionCard {...props} reverse={index % 2 !== 0} />
              </div>
            ))}
        </Collections>
      </Root>
    </>
  )
}

export async function getServerSideProps() {
  const document = await prismic.getSingle('special_collections')

  return {
    props: {
      document,
    },
  }
}
